import Workspace from "../../../core/internal/workspace/Workspace"
import { InAppMessage, HackleUser, InAppMessageEventTriggerRule } from "../../../core/internal/model/model"
import UserEvent, { TrackEvent } from "../../../core/internal/event/UserEvent"
import TargetMatcher from "../../../core/internal/evaluation/match/TargetMatcher"
import { EvaluatorContext } from "../../../core/internal/evaluation/evaluator/Evaluator"
import { EventEvaluateRequest } from "../../../core/internal/evaluation/match/EventConditionMatcher"

export interface InAppMessageEventTriggerMatcher {
  matches(workspace: Workspace, inAppMessage: InAppMessage, event: TrackEvent): boolean
}

export class InAppMessageEventTriggerRuleMatcher implements InAppMessageEventTriggerMatcher {
  constructor(private targetMatcher: TargetMatcher) {}

  public matches(workspace: Workspace, inAppMessage: InAppMessage, event: TrackEvent): boolean {
    return inAppMessage.eventTrigger.rules.some((it) => this.ruleMatches(workspace, event, inAppMessage, it))
  }

  private ruleMatches(
    workspace: Workspace,
    event: TrackEvent,
    inAppMessage: InAppMessage,
    rule: InAppMessageEventTriggerRule
  ): boolean {
    if (event.event.key !== rule.eventKey) {
      return false
    }
    const request = TriggerEventEvaluateRequest.of(workspace, event, inAppMessage)
    return this.targetMatcher.anyMatches(request, EvaluatorContext.create(), rule.targets)
  }
}

class TriggerEventEvaluateRequest implements EventEvaluateRequest {
  readonly record = false

  private constructor(
    public readonly workspace: Workspace,
    public readonly user: HackleUser,
    public readonly entity: InAppMessage,
    public readonly event: UserEvent
  ) {}

  toString(): string {
    return `InAppMessageEventTriggerRequest(key=${this.entity.key})`
  }

  static of(workspace: Workspace, event: UserEvent, inAppMessage: InAppMessage): TriggerEventEvaluateRequest {
    return new TriggerEventEvaluateRequest(workspace, event.user, inAppMessage, event)
  }
}
